"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerFaModelCatalogue = void 0;
const registerFaModelCatalogue = ({ userInteractionService, actionId, modelCatalogueUrl, }) => {
    userInteractionService.register(actionId, {
        getHref: () => modelCatalogueUrl || '',
        action: () => modelCatalogueUrl ? window.open(modelCatalogueUrl, '_blank') : null,
    });
};
exports.registerFaModelCatalogue = registerFaModelCatalogue;
//# sourceMappingURL=registerFaModelCatalogue.js.map